import React from "react";
import styled from "styled-components";
import Logo from "../../../src/Assets/AmanAcademyLogo.png";

const MainDiv = styled.div`
  display: flex;
  justify-content: space-around;
  padding: 25px;
  /* height: 200px; */
  background-color: skyblue;
  flex-direction: column;
  @media screen and (max-width: 767px) {
    padding: 10px;
    display: flex;
    flex-direction: column;
    align-items: center;
  }
`;
const FirstDiv = styled.div`
  @media screen and (max-width: 767px) {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    text-align: center;
  }
`;
const SecondDiv = styled.div`
  @media screen and (max-width: 767px) {
    margin: 10px 0;
  }
`;
const CopyRightDiv = styled.div`
  font-weight: 500;
  font-size: 18px;
  text-align: center;
  background-color: skyblue;
  @media screen and (max-width: 767px) {
    font-size: 12px;
    padding: 0 10px 10px 10px;
  }
`;
const ImgLogo = styled.img`
  width: 120px;
  @media screen and (max-width: 767px) {
    width: 80px;
  }
`;
const ContactInfo = styled.div`
  font-family: "Segoe UI", Roboto, "Helvetica Neue", Arial, sans-serif;
  color: #073763;
  line-height: 1.5;
  h3 {
    margin: 0 0 8px 0;
    font-size: 20px;
    font-weight: 700;
    text-transform: uppercase;
    letter-spacing: 0.6px;
  }
  address {
    font-style: normal;
    font-weight: 400;
    font-size: 15px;
    color: #0b2b4a;
  }
  a {
    color: #0b66b2;
    text-decoration: none;
  }
  a:hover {
    text-decoration: underline;
  }
  @media screen and (max-width: 767px) {
    text-align: center;
  }
`;
const ContactLine = styled.div`
  margin-top: 6px;
`;
const FirstParent = styled.div`
  display: flex;
  justify-content: space-around;
  padding-bottom: 40px;
  @media screen and (max-width: 767px) {
    flex-direction: column;
  }
`;


export default function Footer() {
  return (
    <>
      <MainDiv>
        <FirstParent>
          <FirstDiv>
            <div>
              <ImgLogo src={Logo} />
            </div>
            <ContactInfo>
              <h3>Aman Academy School</h3>
              <address>
                Loam, Darbhanga, Bihar 847115<br />
                <ContactLine>Phone: <a href="tel:+919102846803">+91 91028 46803</a></ContactLine>
                <ContactLine>Phone: <a href="tel:+917004750276">+91 70047 50276</a>, <a href="tel:+918954957699">+91 89549 57699</a></ContactLine>
                <ContactLine>Email: <a href="mailto:principal@amanacademyloam.org">principal@amanacademyloam.org</a></ContactLine>
              </address>
            </ContactInfo>
          </FirstDiv>

          <SecondDiv>
            <iframe
              src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3579.247250663836!2d85.99437891434994!3d26.221154595831308!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x39edc8df3509dedd%3A0x64595ceee9d77f45!2sAman%20Academy!5e0!3m2!1sen!2sin!4v1669574028236!5m2!1sen!2sin"
              style={{
                width: "400px",
                maxWidth: "100%",
                height: "200px",
                outline: "none",
                border: "none",
              }}
              allowFullScreen
              loading="lazy"
              referrerPolicy="no-referrer-when-downgrade"
            ></iframe>
          </SecondDiv>
        </FirstParent>
        <CopyRightDiv>
          © Copyright 2026 All rights reserved by, Aman Academy School, Bihar
        </CopyRightDiv>
      </MainDiv>

    </>
  );
}
